import { html } from 'lit-html';
import { KeywordJsEnv } from '../../../models/keyword_js_env'
import { CatalogAction } from '../../../actions/catalog/catalog_action'

export const catalogBody = (model: KeywordJsEnv) => {
    return html`
    <p class="a-text">の</p>
    <div class="m-tooltipContent js-lazy-img js-catalog_input is-shown">
      <div class="m-tooltipContent_trigger">
        <div class="a-textinput -xxshort -inputAlignright js-input">
          <span class="a-textinput_inputwrap">
            <input type="text" class="a-textinput_input" pattern="\\d*" name="pubPage"
             value="${model.publishedPage}" placeholder="100" maxlength="3" id="publishedPage"
             @input="${() => CatalogAction.inputPublishedPage()}"/>
          </span>
        </div>
      </div>
      ${isInvalidPublishedPage(model)}
    </div>
    <p class="a-text">ページを</p>
    ${searchButton(model)}
    `
}

export const isInvalidPublishedPage = (model: KeywordJsEnv) => {
  if (new RegExp(/^\d*$/).test(model.publishedPage)) {
    return html``
  }
  return html`
  <div class="m-tooltipContent_target">
    <div class="a-tooltip -action -error js-tooltip" style="width:310px">
      <span class="a-tooltip_arrow js-tooltip_arrow" style="left:20px"></span>
      <div class="a-tooltip_content">
        <p class="a-text">ページ番号は半角数字で入力してください。</p>
      </div>
    </div>
  </div>`
}

export const searchButton = (model: KeywordJsEnv) => {
  if (new RegExp(/^\d+$/).test(model.publishedPage)) {
    return html`
    <a href="javascript:catalogArea.submit()" class="m-btn -auto-32">
      <button class="m-btn -auto-32 js-catalog_btn" type="button">
        <span class="m-btn_inner"><span class="m-btn_text">検索</span></span>
      </button>
    </a>
    `
  }
  return html`
  <button class="m-btn -auto-32 is-disabled js-catalog_btn" disabled="" type="button">
    <span class="m-btn_inner"><span class="m-btn_text">検索</span></span>
  </button>
  `
}
